<template>
  <aside class="flex flex-none flex-col gap-5 self-start rounded-ds-lg border border-border bg-card p-4 pb-5 shadow-ds-sm overflow-y-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-muted-foreground/20">
    <slot />
  </aside>
</template>
